import { Component, Input, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { ConversationActionsService } from '../../conversation-actions.service';
import { ConversationSummary } from '../../core/hub-types';

/**
 * A conversation's menu: patient file, details, pin, which messages notify me, and mute. Opened from the chat
 * window's ⋮ and from a conversation list row (right-click or long press): `[matMenuTriggerFor]="ref.menu"`.
 */
@Component({
  selector: 'app-chat-conversation-menu',
  templateUrl: './conversation-menu.component.html',
})
export class ConversationMenuComponent {
  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;
  @Input() conversation: ConversationSummary | null = null;
  /** The conversation's colour, along the top and on the current choice. */
  @Input() accent = '#009688';
  @Input() xPosition: 'before' | 'after' = 'before';

  constructor(readonly actions: ConversationActionsService) {}
}
